const rules = {
    rules: [{
        name: "Need a Belt",
        conditions: [{
            type: "handle",
            rule: "ettore-double-pouch"
        }, {
            type: "handle",
            rule: "facelift®-razr-multi-pouch"
        }],
        show: [{
            variant: "29415956742213",
            show: "Add a Toolbelt",
            handle: "facelift®-tool-belt"
        }]
    }, 
     {
    "name": "Pole Pipe",
    "conditions": [
      {
        "type": "tag",
        "rule": "Pole Pipe Extra"
      }
    ],
    "show": [
      {
        "variant": "19114507862085",
        "show": "10 Metre (32.8ft)",
        "handle": "facelift-5mm-pole-pipe"
      },
      {
        "variant": "39433040068668",
        "show": "20 Metre (65.6ft)",
        "handle": "facelift-5mm-pole-pipe"
      },
      {
        "variant": "39433040691260",
        "show": "30 Metre (98.4ft)",
        "handle": "facelift-5mm-pole-pipe"
      }
    ]
  }, {
  name: "Brush Head",
  conditions: [
    {
      type: "tag",
      rule: "Pole Options"
    }
  ],
  show: [
    {
      variant: "55273324380535",
      show: 'PHANTOM 11" Nylon - Euro Thread',
      handle: "facelift-phantom-dupont-dual-trim-brush"
    },
    {
      variant: "55273324413303",
      show: 'PHANTOM 11" Nylon - Phantom Precision',
      handle: "facelift-phantom-dupont-dual-trim-brush"
    },
    {
      variant: "55273324446071",
      show: 'PHANTOM 11" Horse Hair - Euro Thread',
      handle: "facelift-phantom-dupont-dual-trim-brush"
    },
    {
      variant: "55273324478839",
      show: 'PHANTOM 11" Horse Hair - Phantom Precision',
      handle: "facelift-phantom-dupont-dual-trim-brush"
    },
    {
      variant: "55288936235383",
      show: 'PHOENIX 14" Lightweight - Euro Thread',
      handle: "facelift-phoenix-14-lightweight-brush"
    },
    {
      variant: "55288936333687",
      show: 'PHOENIX 14" Lightweight - Phantom Precision',
      handle: "facelift-phoenix-14-lightweight-brush"
    }]
}, {
        name: "Angle Neck",
        conditions: [{
            type: "tag",
            rule: "Pole Options"
        }],
        show: [{
            variant: "14217904455749",
            show: 'STANDARD 3"',
            handle: "angle-neck-adapter"
        }, {
            variant: "31436516032572",
            show: "FaceLift® PHANTOM Precision Starter Kit",
            handle: "facelift-phantom-precision-angle-neck"
        }]
    }, {
        name: "Angle Neck",
        conditions: [{
            type: "tag",
            rule: "Pole Options Orbital"
        }],
        show: [{
            variant: "14217904455749",
            show: 'STANDARD 3"',
            handle: "angle-neck-adapter"
        }, {
            variant: "55050157392247",
            show: "FaceLift® Orbital Precision Angle Neck Adapter",
            handle: "facelift-orbital-precision-angle-neck-adapter"
        }]
    },{
        name: "OClip Options",
        conditions: [{
            type: "type",
            rule: "Hozelock Fittings"
        }, {
            type: "type",
            rule: "Series 26 Fittings"
        }, {
            type: "type",
            rule: "Series 21 Fittings"
        }, {
            type: "type",
            rule: "Microbore Fittings"
        }, {
            type: "tag",
            rule: "Hose Tail Fittings"
        }],
        show: [{
            variant: "29455640625221",
            show: "5mm Pack of 10",
            handle: "o-clips"
        }, {
            variant: "18980850335813",
            show: "6mm Pack of 10",
            handle: "o-clips"
        }, {
            variant: "18980850401349",
            show: "8mm Pack of 10",
            handle: "o-clips"
        }, {
            variant: "18980850466885",
            show: "12mm Pack of 10",
            handle: "o-clips"
        }, {
            variant: "14011029913669",
            show: "O-Clip Tool",
            handle: "o-clip-tool"
        }]
    }, {
        name: "Hose Connectors",
        conditions: [{
            type: "tag",
            rule: "Pole Options"
        }],
        show: [{
            variant: "19114599514181",
            show: "6mm Series 21 Male",
            handle: "series-21-male-hose-tail-couplings"
        }, {
            variant: "14011026243653",
            show: "6mm Hozelock Male",
            handle: "hose-tail-to-hozelock-male-connectors"
        }]
    }, {
        name: "Add a Fitting Kit",
        conditions: [{
            type: "handle",
            rule: "vyair-ro-system"
        }],
        show: [{
            variant: "14011053277253",
            show: "Hoselock Fittings Kit",
            handle: "filterplus-300gpd-fittings-kit"
        }]
    }]
};

window['rules'] = rules;
const RulesFunc = {
	init: function() {
		let infiniteRules = '';
		let infiniteEl = document.querySelector('#infinite');
		let selector = document.querySelector('#variant-select');
		let shopifyPaymentBtn = document.querySelector('.shopify-payment-button')

		if(infiniteEl) {
			for (var i = 0; i < rules['rules'].length; i++) {
				let rule = rules['rules'][i];
				for (var j = 0; j < rule['conditions'].length; j++) {
					let condition = rule['conditions'][j]
					if(condition['type'] == "tag") {
						if(fullProduct['tags'].includes(condition['rule'])) {
							infiniteRules = infiniteRules + this.createRuleOption(rule);
						};
					} else if(condition['type'] == "handle") {
						if(condition['rule'] == fullProduct['handle']) {
							infiniteRules = infiniteRules + this.createRuleOption(rule);
						};
					} else if(condition['type'] == "type") {
						if(condition['rule'] == fullProduct['type']) {
							infiniteRules = infiniteRules + this.createRuleOption(rule);
						};
					} else {
						if(condition['rule'] == fullProduct['title']) {
							infiniteRules = infiniteRules + this.createRuleOption(rule);
						};
					};
				}
			}

			infiniteEl.innerHTML = infiniteRules;
			selector.setAttribute('name', 'id[]');
			shopifyPaymentBtn.parentNode.removeChild(shopifyPaymentBtn);
		}
	},

	createRuleOption: function(rule) {
		console.log(rule)
		let select = `<div class="rule__option bundle__select"><label for="${rule['name'].replace(' ', '')}">${rule['name']}</label><select class="select-std" name="id[]" id="${rule['name'].replace(' ', '')}"><option disabled selected hidden>None</option><option value="">None</option>`;
		for (var i = 0; i < rule['show'].length; i++) {
			let option = rule['show'][i];
			select = select + `<option value="${option['variant']}">${option['show']}</option>`
		}
		select = select + '</select></div>'
		return select;
	}
};

